 import React, { useState, useEffect } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { getDatabase, ref, onValue, set } from "firebase/database";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimes,
  faCheck,
  faCheckCircle,
  faEnvelope,
  faFilePdf,
  faMapMarkerAlt,
  faClock,
  faStar,
  faEye,
  faTags
} from "@fortawesome/free-solid-svg-icons";
import SEO from "./SEO";
import { jsPDF } from "jspdf";
import logo from "../assets/logo.png";
import logo1 from "../assets/image1.jpg";

const EnquiryForm = ({ onClose, tour }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    travellers: "",
    date: "",
    destination: tour?.destination || "",
    tourName: tour?.name || "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const database = getDatabase();
      const enquiryRef = ref(database, `enquiry/${formData.mobile}`);
      await set(enquiryRef, {
        ...formData,
        status: "pending",
        timestamp: new Date().toISOString(),
      });
      alert("Enquiry submitted successfully!");
      onClose();
    } catch (error) {
      console.error("Error submitting enquiry:", error);
      alert("Failed to submit enquiry. Please try again.");
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close-btn" onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </button>

        <div className="modal-header">
          <h2>Send us a Query</h2>
          <p>
            Ready to venture out into the world? Fill the form below and start
            your brand new journey with us
          </p>
        </div>

        <form onSubmit={handleSubmit} className="enquiry-form">
          <div className="form-group">
            <label>Name*</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Email*</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Mobile*</label>
            <input
              type="tel"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>No of travellers*</label>
            <input
              type="number"
              name="travellers"
              value={formData.travellers}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Date*</label>
              <input
                type="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Destination*</label>
              <input
                type="text"
                name="destination"
                value={formData.destination}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <button type="submit" className="submit-btn">
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

const TourDetailsModal = ({ tour, onClose }) => {
  const [showEnquiryForm, setShowEnquiryForm] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);



const generatePDF = async () => {
  if (!tour) return;

  const PAGE_WIDTH = 210; // A4 width in mm
  const LEFT_MARGIN = 20;
  const RIGHT_MARGIN = 20;
  const CONTENT_WIDTH = PAGE_WIDTH - LEFT_MARGIN - RIGHT_MARGIN;
  const TOP_MARGIN = 20;
  const BOTTOM_MARGIN = 275;

  const ensureSafeY = (requiredSpace = 10) => {
    if (yPosition + requiredSpace > BOTTOM_MARGIN) {
      doc.addPage();
      yPosition = TOP_MARGIN;
      return true;
    }
    return false;
  };

  // Load logo
  const img = new Image();
  img.src = logo1;
  await new Promise((resolve) => (img.onload = resolve));

  const canvas = document.createElement("canvas");
  canvas.width = img.width;
  canvas.height = img.height;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0);
  const dataURL = canvas.toDataURL("image1/png");

  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });

  let yPosition = 10;

  // LOGO
  const logoWidth = 200;
  const logoHeight = 100;
  const centerX = 105 - logoWidth / 2;
  doc.addImage(dataURL, "PNG", centerX, yPosition, logoWidth, logoHeight);
  yPosition += logoHeight + 5;

  // HEADER
  

  // PACKAGE DETAILS
  doc.setFontSize(16);
  doc.setTextColor(30, 58, 138);
  doc.setFont("helvetica", "bold");
  doc.text("TOUR PACKAGE DETAILS", 105, yPosition, { align: "center" });
  yPosition += 15;

  doc.setDrawColor(200, 200, 200);
  doc.setLineWidth(0.5);
  doc.line(LEFT_MARGIN, yPosition, PAGE_WIDTH - RIGHT_MARGIN, yPosition);
  yPosition += 10;

  // PACKAGE INFO
  ensureSafeY(40);
  doc.setFontSize(18);
  doc.setTextColor(30, 58, 138);
  doc.setFont("helvetica", "bold");
  doc.text(tour.name.toUpperCase(), LEFT_MARGIN, yPosition);
  yPosition += 10;

  doc.setFontSize(12);
  doc.setTextColor(80, 80, 80);
  doc.setFont("helvetica", "normal");
  doc.text(`Destination: ${tour.destination}`, LEFT_MARGIN, yPosition);
  yPosition += 7;
  doc.text(`Duration: ${tour.duration}`, LEFT_MARGIN, yPosition);
  yPosition += 7;

  // PRICES SECTION - FIXED OVERLAP ISSUE
  doc.setFontSize(12);
  doc.setTextColor(30, 58, 138);
  doc.setFont("helvetica", "bold");
  doc.text("PRICE DETAILS", LEFT_MARGIN, yPosition);
  yPosition += 7;

  doc.setFontSize(12);
  doc.setFont("helvetica", "normal");

  if (tour.priceValues && typeof tour.priceValues === 'object' && Object.keys(tour.priceValues).length > 0) {
    doc.setFillColor(241, 243, 245);
    doc.rect(LEFT_MARGIN - 5, yPosition, CONTENT_WIDTH + 10, 8, "F");
    
    doc.setFontSize(10);
    doc.setTextColor(30, 58, 138);
    doc.text("PRICES", LEFT_MARGIN, yPosition + 6);
    yPosition += 15;

    // Display each price with its label - matching card display logic
    if (tour.priceValues) {
      // If priceValues is an array, use it directly
      if (Array.isArray(tour.priceValues)) {
        tour.priceValues.forEach((priceValue, index) => {
          ensureSafeY(10);
          let displayText = priceValue?.toString() || '0';
          // Format the price to match card display
          displayText = displayText.replace(/(\d+)/g, (match) => 
            `₹${parseInt(match).toLocaleString('en-IN')}`
          );
          
          // Split long price text to prevent overflow
          const priceLines = doc.splitTextToSize(`Price ${index + 1}: ${displayText}`, CONTENT_WIDTH);
          doc.text(priceLines, LEFT_MARGIN, yPosition);
          yPosition += priceLines.length * 8;
        });
      } 
      // If it's an object, display with labels
      else if (typeof tour.priceValues === 'object' && tour.priceValues !== null) {
        Object.entries(tour.priceValues).forEach(([priceLabel, priceValue]) => {
          ensureSafeY(10);
          let displayText = priceValue?.toString() || '0';
          // Format the price to match card display
          displayText = displayText.replace(/(\d+)/g, (match) => 
            `₹${parseInt(match).toLocaleString('en-IN')}`
          );
          
          // Split long price text to prevent overflow
          const priceLines = doc.splitTextToSize(`${priceLabel}: ${displayText}`, CONTENT_WIDTH);
          doc.text(priceLines, LEFT_MARGIN, yPosition);
          yPosition += priceLines.length * 8;
        });
      }
    } 
    // Fallback to single price
    else if (tour.price) {
      ensureSafeY(10);
      let displayText = tour.price.toString();
      // Format the price to match card display
      displayText = displayText.replace(/(\d+)/g, (match) => 
        `₹${parseInt(match).toLocaleString('en-IN')}`
      );
      
      // Split long price text to prevent overflow
      const priceLines = doc.splitTextToSize(`Price: ${displayText}`, CONTENT_WIDTH);
      doc.text(priceLines, LEFT_MARGIN, yPosition);
      yPosition += priceLines.length * 8;
    }
    
    // Add separator line if there's space after all prices are displayed
    if (yPosition < BOTTOM_MARGIN - 10) {
      doc.setDrawColor(220, 220, 220);
      doc.setLineWidth(0.2);
      doc.line(LEFT_MARGIN + 5, yPosition, PAGE_WIDTH - RIGHT_MARGIN, yPosition);
      yPosition += 5;
    }
    
    // Display total price if available - matching card display logic
    if (tour.totalPrice) {
      ensureSafeY(15);
      doc.setFont("helvetica", "bold");
      
      let displayText = tour.totalPrice.toString();
      // Format the price to match card display
      displayText = displayText.replace(/(\d+)/g, (match) => 
        `₹${parseInt(match).toLocaleString('en-IN')}`
      );
      
      // Split long price text to prevent overflow
      const totalPriceLines = doc.splitTextToSize(`Total Package Price: ${displayText}`, CONTENT_WIDTH);
      doc.text(totalPriceLines, LEFT_MARGIN, yPosition);
      yPosition += totalPriceLines.length * 10;
    }
  } else {
    doc.text("No pricing information available", LEFT_MARGIN, yPosition);
    yPosition += 7;
  }

  yPosition += 10;

  // ALWAYS START DESCRIPTION ON A NEW PAGE
  doc.addPage();
  yPosition = TOP_MARGIN;

  // DESCRIPTION
  const descriptionHeadingHeight = 10;
  const descriptionContent = tour.description || "No description available";
  const descriptionLines = doc.splitTextToSize(descriptionContent, CONTENT_WIDTH);
  const lineHeight = 6;

  // Add the description heading
  doc.setFontSize(14);
  doc.setTextColor(30, 58, 138);
  doc.setFont("helvetica", "bold");
  doc.text("DESCRIPTION", LEFT_MARGIN, yPosition);
  yPosition += descriptionHeadingHeight;

  // Add description content line by line with proper pagination
  doc.setFontSize(10);
  doc.setTextColor(50, 50, 50);

  for (let i = 0; i < descriptionLines.length; i++) {
    // Check if we need a new page for this line
    if (yPosition + lineHeight > BOTTOM_MARGIN) {
      doc.addPage();
      yPosition = TOP_MARGIN;
    }
    
    doc.text(descriptionLines[i], LEFT_MARGIN, yPosition);
    yPosition += lineHeight;
  }

  yPosition += 15; // Add spacing after description

  // ITINERARY - FIXED DAY NUMBER DISPLAY
  if (tour.itinerary && typeof tour.itinerary === 'object' && Object.keys(tour.itinerary).length > 0) {
    // Check if we need a new page before adding itinerary
    if (yPosition > TOP_MARGIN + 50) {
      doc.addPage();
      yPosition = TOP_MARGIN;
    }

    doc.setFontSize(16);
    doc.setTextColor(30, 58, 138);
    doc.setFont("helvetica", "bold");
    doc.text("DETAILED ITINERARY", 105, yPosition, { align: "center" });
    yPosition += 15;

    // Convert itinerary object to array if needed
    const itineraryArray = Array.isArray(tour.itinerary) 
      ? tour.itinerary 
      : Object.values(tour.itinerary);
    
    // Iterate through each day
    itineraryArray.forEach((description, index) => {
      const dayNumber = index + 1;
      const descLines = doc.splitTextToSize(description, CONTENT_WIDTH);
      const dayHeight = 10 + descLines.length * 6 + 10;
      
      // Check if we need a new page for this day
      if (yPosition + dayHeight > BOTTOM_MARGIN) {
        doc.addPage();
        yPosition = TOP_MARGIN;
      }

      doc.setFillColor(241, 243, 245);
      doc.rect(LEFT_MARGIN - 5, yPosition, CONTENT_WIDTH + 10, 8, "F");
      doc.setFontSize(14);
      doc.setTextColor(30, 58, 138);
      doc.text(`Day ${dayNumber}`, LEFT_MARGIN, yPosition + 6);
      yPosition += 10;

      doc.setFontSize(12);
      doc.setTextColor(50, 50, 50);
      doc.text(descLines, LEFT_MARGIN, yPosition + 5);
      yPosition += descLines.length * 6 + 10;
    });
  }

  // INCLUSIONS & EXCLUSIONS
  // Check if we need a new page before adding inclusions
  if (yPosition > TOP_MARGIN + 50) {
    doc.addPage();
    yPosition = TOP_MARGIN;
  }

  // INCLUSIONS
  doc.setFontSize(16);
  doc.setTextColor(30, 58, 138);
  doc.setFont("helvetica", "bold");
  doc.text("INCLUSIONS", LEFT_MARGIN, yPosition);
  yPosition += 10;

  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");

  if (tour.includes && typeof tour.includes === 'object') {
    // Convert to array if needed
    const includesArray = Array.isArray(tour.includes) 
      ? tour.includes 
      : Object.values(tour.includes);
    
    includesArray.forEach((item) => {
      // Check if we need a new page for each inclusion item
      if (yPosition + 7 > BOTTOM_MARGIN) {
        doc.addPage();
        yPosition = TOP_MARGIN;
      }
      
      // Split long inclusion text to prevent overflow
      const itemLines = doc.splitTextToSize(`• ${item}`, CONTENT_WIDTH);
      doc.text(itemLines, LEFT_MARGIN - 5, yPosition);
      yPosition += itemLines.length * 7;
    });
  } else {
    doc.text("No inclusions listed.", LEFT_MARGIN + 5, yPosition);
    yPosition += 7;
  }

  yPosition += 10;

  // EXCLUSIONS
  // Check if we need a new page before adding exclusions
  if (yPosition + 20 > BOTTOM_MARGIN) {
    doc.addPage();
    yPosition = TOP_MARGIN;
  }

  doc.setFontSize(16);
  doc.setTextColor(30, 58, 138);
  doc.setFont("helvetica", "bold");
  doc.text("EXCLUSIONS", LEFT_MARGIN, yPosition);
  yPosition += 10;

  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");

  if (tour.excludes && typeof tour.excludes === 'object') {
    // Convert to array if needed
    const excludesArray = Array.isArray(tour.excludes) 
      ? tour.excludes 
      : Object.values(tour.excludes);
    
    excludesArray.forEach((item) => {
      // Check if we need a new page for each exclusion item
      if (yPosition + 7 > BOTTOM_MARGIN) {
        doc.addPage();
        yPosition = TOP_MARGIN;
      }
      
      // Split long exclusion text to prevent overflow
      const itemLines = doc.splitTextToSize(`• ${item}`, CONTENT_WIDTH);
      doc.text(itemLines, LEFT_MARGIN - 5, yPosition);
      yPosition += itemLines.length * 7;
    });
  } else {
    doc.text("No exclusions listed.", LEFT_MARGIN + 5, yPosition);
    yPosition += 7;
  }

  // TERMS & CONDITIONS
  if (tour.termsAndConditions) {
    // Check if we need a new page before adding terms
    if (yPosition + 50 > BOTTOM_MARGIN) {
      doc.addPage();
      yPosition = TOP_MARGIN;
    } else {
      yPosition += 15;
    }

    doc.setFontSize(16);
    doc.setTextColor(30, 58, 138);
    doc.setFont("helvetica", "bold");
    doc.text("TERMS & CONDITIONS", 105, yPosition, { align: "center" });
    yPosition += 15;

    doc.setFontSize(11);
    doc.setTextColor(80, 80, 80);
    doc.setFont("helvetica", "normal");

    const termsLines = doc.splitTextToSize(tour.termsAndConditions, CONTENT_WIDTH);
    const termsHeight = termsLines.length * 6;
    
    // Check if we need a new page for terms
    if (yPosition + termsHeight > BOTTOM_MARGIN) {
      doc.addPage();
      yPosition = TOP_MARGIN;
    }
    
    doc.text(termsLines, LEFT_MARGIN, yPosition);
    yPosition += termsHeight + 10;
  }

  // FOOTER ON ALL PAGES
  const pageCount = doc.internal.getNumberOfPages();
  const footerY = 287;

  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setDrawColor(200, 200, 200);
    doc.setLineWidth(0.3);
    doc.line(LEFT_MARGIN, footerY - 5, PAGE_WIDTH - RIGHT_MARGIN, footerY - 5);

    doc.setFontSize(10);
    doc.setTextColor(100, 100, 100);
    doc.text(`Page ${i} of ${pageCount}`, 105, footerY, { align: "center" });
    doc.text("Pearl Tours & Travels", LEFT_MARGIN, footerY);
    doc.text(new Date().toLocaleDateString(), PAGE_WIDTH - RIGHT_MARGIN, footerY, {
      align: "right",
    });
  }

  doc.save(`${tour.name.replace(/\s+/g, "_")}_package_details.pdf`);
};




  if (!tour) return null;

  return (
    <>
      <div
        className="modal-overlay"
        onClick={(e) => {
          if (e.target === e.currentTarget) {
            onClose();
          }
        }}
      >
        <div className="modal-container">
          <button className="modal-close-btn" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>

          <div className="modal-header">
            <h2>{tour.name}</h2>
            <div className="modal-subheader">
              <span className="modal-location">
                <i className="fas fa-map-marker-alt"></i> {tour.destination}
              </span>
              <span className="modal-duration">
                <i className="far fa-clock"></i> {tour.duration}
              </span>
            </div>
          </div>

          <div className="modal-image-gallery">
            <div className="main-image">
              <img
                src={
                  selectedImage ||
                  tour.images?.[0] ||
                  "https://via.placeholder.com/800x500?text=No+Image"
                }
                alt={tour.name}
                onClick={() =>
                  tour.images?.[0] && setSelectedImage(tour.images[0])
                }
              />
            </div>
            <div className="thumbnail-container">
              {(tour.images || []).slice(0, 4).map((img, index) => (
                <div
                  key={index}
                  className="thumbnail"
                  onClick={() => setSelectedImage(img)}
                >
                  <img src={img} alt={`${tour.name} ${index + 1}`} />
                </div>
              ))}
            </div>
          </div>

          {selectedImage && (
            <div
              className="image-popup-overlay"
              onClick={() => setSelectedImage(null)}
            >
              <div
                className="image-popup-container"
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  className="popup-close-btn"
                  onClick={() => setSelectedImage(null)}
                >
                  <FontAwesomeIcon icon={faTimes} />
                </button>
                <img
                  src={selectedImage}
                  alt="Enlarged view"
                  className="popup-image"
                />
              </div>
            </div>
          )}

          <div className="modal-content">
  <div className="modal-price-section">
    <div className="price-box">
      <span className="itinerary">
        Description : <br />
        {tour.description}
      </span>
      
      {/* Display all price options in modal */}
      <div className="modal-price-options">
        {tour.priceValues && tour.priceValues.length > 0 ? (
          <div className="price-section">
            <div className="price-header">
              <FontAwesomeIcon icon={faTags} className="price-icon" />
              <h4 className="price-title"> PRICES </h4>
            </div>
            <div className="price-list">
              {tour.priceValues.map((priceText, index) => {
                const formattedPrice = priceText.toString().replace(/(\d+)/g, (match) => 
                  `₹${parseInt(match).toLocaleString('en-IN')}`
                );
                return (
                  <div key={index} className={`price-option ${index === 0 ? 'highlighted' : ''}`}>
                    <div className="price-badge">{index + 1}</div>
                    <div className="price-details">
                      <span className="price-value">{formattedPrice}</span>
                      {index === 0 && <span className="best-value">Best Value</span>}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          <div className="single-price">
            <span className="price-amount">
              ₹{(tour.price || 0).toLocaleString('en-IN')}
            </span>
            {tour.priceType && (
              <span className="price-type"> {tour.priceType}</span>
            )}
          </div>
        )}
      </div>

      <button
        className="enquiry-now-btn"
        onClick={() => setShowEnquiryForm(true)}
      >
        <FontAwesomeIcon icon={faEnvelope} /> Enquiry Now
      </button>

      <button className="download-pdf-btn" onClick={generatePDF}>
        <FontAwesomeIcon icon={faFilePdf} /> Download PDF
      </button>
    </div>
  </div>

  <div className="modal-details-section">
    <h3>Package Highlights</h3>
    <ul className="highlights-list">
      {(tour.highlights || []).map((item, index) => (
        <li key={index}>
          <FontAwesomeIcon icon={faCheckCircle} /> {item}
        </li>
      ))}
    </ul>

    <h3>Detailed Itinerary</h3>
    <div className="itinerary">
      {tour.itinerary && typeof tour.itinerary === 'object' ? (
        Object.entries(tour.itinerary).map(
          ([dayTitle, description], index) => (
            <div key={index} className="day-plan">
              <h4>{dayTitle}</h4>
              <p>{description}</p>
            </div>
          )
        )
      ) : (
        <p>No detailed itinerary available.</p>
      )}
    </div>

    <h3>Included</h3>
    <ul className="inclusions-list">
      {tour.includes && typeof tour.includes === 'object' ? (
        Object.values(tour.includes).map((item, index) => (
          <li key={index}>
            <FontAwesomeIcon icon={faCheck} /> {item}
          </li>
        ))
      ) : (
        <li>No inclusions listed.</li>
      )}
    </ul>

    <h3>Exclusions</h3>
    <ul className="exclusions-list">
      {tour.excludes && typeof tour.excludes === 'object' ? (
        Object.values(tour.excludes).map((item, index) => (
          <li key={index}>
            <FontAwesomeIcon icon={faTimes} /> {item}
          </li>
        ))
      ) : (
        <li>No exclusions listed.</li>
      )}
    </ul>

    {tour.termsAndConditions && (
      <>
        <h3>Terms & Conditions</h3>
        <p className="terms">{tour.termsAndConditions}</p>
      </>
    )}
  </div>
</div>
        </div>
      </div>

      {showEnquiryForm && (
        <EnquiryForm onClose={() => setShowEnquiryForm(false)} tour={tour} />
      )}
    </>
  );
};

export default function InternationalTourPackages() {
  const [priceRange, setPriceRange] = useState([0, 1500000]);
  const [visibleCount, setVisibleCount] = useState(3);
  const [selectedDestinations, setSelectedDestinations] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [allPackages, setAllPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTour, setSelectedTour] = useState(null);



useEffect(() => {
  const database = getDatabase();
  const packagesRef = ref(database, "packages");

  const unsubscribe = onValue(packagesRef, (snapshot) => {
    if (!snapshot.exists()) {
      console.log("No data available");
      setLoading(false);
      return;
    }

    const data = snapshot.val();
    const packagesArray = [];
    console.log("Raw Firebase data:", data); // Debug log

    Object.keys(data).forEach((country) => {
      Object.keys(data[country]).forEach((packageName) => {
        const pkg = data[country][packageName];
        
        // Debug log to check each package
        console.log(`Processing package: ${packageName} from ${country}`, pkg);

        // Check if package exists and is international type (case-insensitive)
        if (pkg && pkg.type && pkg.type.toLowerCase() === "international") {
          console.log(`Found international package: ${pkg.name}`); // Debug log
          
          // Handle price values
          let priceValues = [];
          let displayPrice = 0;
          let displayPriceText = "0";

          if (pkg.priceValues) {
            // If priceValues is an array, use it directly
            if (Array.isArray(pkg.priceValues)) {
              priceValues = [...pkg.priceValues];
            } 
            // If it's an object, convert to array
            else if (typeof pkg.priceValues === 'object') {
              priceValues = Object.values(pkg.priceValues);
            }

            // Get the first price value for sorting/filtering
            const firstPrice = priceValues[0] || "0";
            displayPriceText = firstPrice;
            displayPrice = parseInt(firstPrice.toString().replace(/\D/g, '')) || 0;
          } else {
            // Fallback to regular price field
            displayPriceText = pkg.price?.toString() || "0";
            displayPrice = parseInt(pkg.price?.toString().replace(/\D/g, '')) || 0;
          }

          packagesArray.push({
            id: `${country}-${packageName}`,
            ...pkg,
            priceValues, // normalized price values
            displayPrice,
            displayPriceText,
            formattedPrice: `₹${displayPrice.toLocaleString('en-IN')}`
          });
        }
      });
    });

    console.log("Processed packages array:", packagesArray); // Debug log
    setAllPackages(packagesArray);
    setLoading(false);
  }, (error) => {
    console.error("Error fetching data:", error);
    setLoading(false);
  });

  return () => unsubscribe();
}, []);


  
const filteredPackages = allPackages.filter((pkg) => {
  const priceMatch = pkg.displayPrice >= priceRange[0] && pkg.displayPrice <= priceRange[1];

    const destinationMatch =
      selectedDestinations.length === 0 ||
      selectedDestinations.includes(pkg.destination);

    const searchMatch =
      (pkg.name?.toLowerCase().includes(searchQuery.toLowerCase()) ?? false) ||
      (pkg.destination?.toLowerCase().includes(searchQuery.toLowerCase()) ??
        false) ||
      (pkg.highlights?.some((highlight) =>
        highlight?.toLowerCase().includes(searchQuery.toLowerCase())
      ) ??
        false);

    return priceMatch && destinationMatch && searchMatch;
  });

  const displayedPackages = filteredPackages.slice(0, visibleCount);

  const loadMorePackages = () => {
    setVisibleCount((prev) => Math.min(prev + 3, filteredPackages.length));
  };

  const showLessPackages = () => {
    setVisibleCount(3);
  };

  const handleDestinationChange = (destination) => {
    setSelectedDestinations((prev) =>
      prev.includes(destination)
        ? prev.filter((d) => d !== destination)
        : [...prev, destination]
    );
  };

  const resetFilters = () => {
    setPriceRange([0, 150000]);
    setSelectedDestinations([]);
    setSearchQuery("");
  };

  // Extract unique destinations from packages
  const destinations = Array.from(
    new Set(allPackages.map((pkg) => pkg.destination))
  ).filter((dest) => dest);

  const TourCard = ({ tour, onClick }) => (
  <div className="card">
    <div className="card-image-container">
      {tour.bestSelling && <span className="badge">Best Seller</span>}
      <img
        src={
          tour.images?.[0] ||
          "https://via.placeholder.com/300x200?text=No+Image"
        }
        alt={tour.name}
        className="card-image"
      />
      <div className="location-tag">
        <FontAwesomeIcon icon={faMapMarkerAlt} /> {tour.destination}
      </div>
    </div>
    <div className="card-content">
      <div className="card-header">
        <h2 className="card-title">{tour.name}</h2>
        <div className="card-duration">
          <FontAwesomeIcon icon={faClock} /> {tour.duration}
        </div>
      </div>
      <div className="card-rating-price">
        <div className="card-rating">
          {[...Array(5)].map((_, i) => (
            <FontAwesomeIcon
              key={i}
              icon={faStar}
              color={i < (tour.rating || 5) ? "#FFD700" : "#C0C0C0"}
            />
          ))}
          <span>({tour.rating || 5}.0)</span>
        </div>
        <div className="card-price">
          {tour.priceValues && tour.priceValues.length > 0 ? (
            <div className="price-container">
              <div className="single-price-display">
                <span className="price-amount">
                  {tour.priceValues[0].toString().replace(/(\d+)/g, (match) => 
                    `₹${parseInt(match).toLocaleString('en-IN')}`
                  )}
                </span>
                {tour.priceType && (
                  <span className="price-type"> {tour.priceType}</span>
                )}
              </div>
            </div>
          ) : (
            <div className="single-price">
              <span className="price-amount">
                ₹{(tour.price || 0).toLocaleString('en-IN')}
              </span>
              {tour.priceType && (
                <span className="per-person"> {tour.priceType}</span>
              )}
            </div>
          )}
          <style jsx>{`
            .price-container {
              display: flex;
              flex-direction: column;
              gap: 6px;
              padding: 8px 0 0 0;
            }
            .price-item {
              display: flex;
              align-items: center;
              gap: 8px;
              font-size: 14px;
              line-height: 1.4;
            }
            .price-number {
              font-weight: 600;
              color: #2c3e50;
              min-width: 20px;
            }
            .price-text {
              color: #2c3e50;
              font-weight: 500;
            }
            .price-item:first-child .price-text {
              color: #e74c3c;
              font-weight: 600;
            }
            .per-person {
              font-size: 0.8em;
              color: #666;
              margin-left: 4px;
            }
            .single-price {
              font-weight: 600;
              color: #2c3e50;
            }
          `}</style>
        </div>
      </div>
      <div className="card-highlights">
        <h4>Highlights:</h4>
        <p>{tour.description?.split(" ").slice(0, 15).join(" ")}...</p>
      </div>
      <div className="card-footer">
        <button className="view-btn" onClick={onClick}>
          <FontAwesomeIcon icon={faEye} /> View Details
        </button>
      </div>
    </div>
  </div>
);


  return (
    <>
         <SEO
        title="International Tours | Pearl Tours & Travels"
        description="Explore our exclusive international tour packages to top destinations around the world."
        keywords="international tours, world travel packages, Europe tours, USA travel, Asia trips, holiday packages abroad"
      />
      <Navbar />
      
      <div className="container">
        <h1 className="title">International Tour Packages</h1>
        <p className="subtitle">
          Discover handcrafted tour packages to the world's most enchanting
          destinations, carefully designed for unforgettable experiences
        </p>

        {/* Search Box */}
        <div className="search-container">
          <div className="search-box">
            <input
              type="text"
              placeholder="Search packages by title, destination, or highlights..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
        </div>

        <div className="layout">
          <div className="filter-container">
            {/* Price Filter */}
            <div className="filter-box">
              <div className="filter-header">
                <span>Price Range</span>
              </div>
              <div className="slider-labels">
                <span>₹{priceRange[0].toLocaleString()}</span>
                <span>₹{priceRange[1].toLocaleString()}</span>
              </div>
              <input
                type="range"
                min="0"
                max="150000"
                step="1000"
                value={priceRange[0]}
                onChange={(e) =>
                  setPriceRange([+e.target.value, priceRange[1]])
                }
                className="range-slider"
              />
              <input
                type="range"
                min="0"
                max="150000"
                step="1000"
                value={priceRange[1]}
                onChange={(e) =>
                  setPriceRange([priceRange[0], +e.target.value])
                }
                className="range-slider"
              />
              <div className="price-inputs">
                <input
                  type="number"
                  value={priceRange[0]}
                  onChange={(e) =>
                    setPriceRange([+e.target.value, priceRange[1]])
                  }
                  placeholder="Min Price"
                  min="0"
                />
                <input
                  type="number"
                  value={priceRange[1]}
                  onChange={(e) =>
                    setPriceRange([priceRange[0], +e.target.value])
                  }
                  placeholder="Max Price"
                  max="150000"
                />
              </div>
              <div className="buttons">
                <button className="clear-btn" onClick={resetFilters}>
                  Reset
                </button>
              </div>
            </div>

            {/* Destinations Filter */}
            <div className="filter-box">
              <div className="filter-header">
                <span>Destinations</span>
              </div>
              <div className="checkboxes scrollable">
                {destinations.map((dest) => (
                  <div key={dest} className="checkbox-item">
                    <input
                      type="checkbox"
                      id={`dest-${dest}`}
                      checked={selectedDestinations.includes(dest)}
                      onChange={() => handleDestinationChange(dest)}
                    />
                    <label htmlFor={`dest-${dest}`}>{dest}</label>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="cards-container">
            {loading ? (
              <div className="loading-container">
                <div className="spinner"></div>
              </div>
            ) : filteredPackages.length > 0 ? (
              <>
                <div className="cards">
                  {displayedPackages.map((tour) => (
                    <TourCard key={tour.id} tour={tour}  onClick={() => setSelectedTour(tour)}/>
                  ))}
                </div>

                <div className="load-buttons">
                  {visibleCount < filteredPackages.length && (
                    <button
                      className="load-more-btn"
                      onClick={loadMorePackages}
                    >
                      Load More
                    </button>
                  )}
                  {visibleCount > 3 && (
                    <button
                      className="show-less-btn"
                      onClick={showLessPackages}
                    >
                      Show Less
                    </button>
                  )}
                </div>
              </>
            ) : (
              <div className="no-results">
                <h3>No packages match your filters</h3>
                <p>Try adjusting your search criteria or reset the filters</p>
                <button
                  className="load-more-btn"
                  onClick={resetFilters}
                >
                  Reset Filters
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {selectedTour && (
        <TourDetailsModal
          tour={selectedTour}
          onClose={() => setSelectedTour(null)}
        />
      )}

      <Footer />

      <style jsx>{`
        :root {
          --primary: #64192e;
          --primary-dark: #64192e;
          --dark: #2f3542;
          --light: #f1f2f6;
          --gray: #a4b0be;
          --white: #ffffff;
          --shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
          --transition: all 0.3s ease;
        }

        * {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
          font-family: "Poppins", sans-serif;
        }

        .container {
          max-width: 1400px;
          margin: 0 auto;
          padding: 2rem 1rem;
        }

        .title {
          font-size: 2.5rem;
          color: var(--dark);
          text-align: center;
          margin-bottom: 1rem;
        }

        .subtitle {
          text-align: center;
          color: var(--gray);
          max-width: 700px;
          margin: 0 auto 3rem;
          font-size: 1.1rem;
          line-height: 1.6;
        }

        .search-container {
          max-width: 800px;
          margin: 0 auto 3rem;
          width: 100%;
        }

        .search-box {
          display: flex;
          border-radius: 50px;
          overflow: hidden;
          box-shadow: var(--shadow);
          background: var(--white);
          transition: var(--transition);
          border: 1px solid rgba(0, 0, 0, 0.1);
        }

        .search-box:hover {
          box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
        }

        .search-box input {
          flex: 1;
          padding: 1.2rem 1.5rem;
          border: none;
          font-size: 1rem;
          background: transparent;
          color: var(--dark);
        }

        .search-box input::placeholder {
          color: var(--gray);
        }

        .search-box input:focus {
          outline: none;
        }

        .layout {
          display: grid;
          grid-template-columns: 280px 1fr;
          gap: 2rem;
          margin-bottom: 3rem;
        }

        .filter-container {
          background: var(--white);
          border-radius: 10px;
          padding: 1.5rem;
          box-shadow: var(--shadow);
          height: fit-content;
          position: sticky;
          top: 1rem;
        }

        .filter-box {
          margin-bottom: 2rem;
          border-bottom: 1px solid rgba(0, 0, 0, 0.05);
          padding-bottom: 1.5rem;
        }

        .filter-box:last-child {
          border-bottom: none;
          margin-bottom: 0;
          padding-bottom: 0;
        }

        .filter-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 1.5rem;
          font-weight: 600;
          color: var(--dark);
        }

        .slider-labels {
          display: flex;
          justify-content: space-between;
          margin-bottom: 0.5rem;
          font-size: 0.9rem;
          color: var(--gray);
        }

        .range-slider {
          width: 100%;
          margin-bottom: 1rem;
          -webkit-appearance: none;
          height: 6px;
          border-radius: 3px;
          background: var(--light);
          outline: none;
        }

        .range-slider::-webkit-slider-thumb {
          -webkit-appearance: none;
          appearance: none;
          width: 18px;
          height: 18px;
          border-radius: 50%;
          background: var(--primary);
          cursor: pointer;
          transition: var(--transition);
        }

        .range-slider::-webkit-slider-thumb:hover {
          transform: scale(1.2);
        }

        .price-inputs {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 1rem;
          margin-bottom: 1.5rem;
        }

        .price-inputs input {
          width: 100%;
          padding: 0.5rem 1rem;
          border: 1px solid var(--light);
          border-radius: 5px;
          font-size: 0.9rem;
        }

        .price-inputs input:focus {
          outline: none;
          border-color: var(--primary);
        }

        .buttons {
          display: flex;
          gap: 1rem;
        }

        .clear-btn,
        .apply-btn {
          flex: 1;
          padding: 0.7rem;
          border-radius: 5px;
          font-weight: 600;
          cursor: pointer;
          transition: var(--transition);
        }

        .clear-btn {
          background: var(--light);
          color: var(--dark);
          border: none;
        }

        .clear-btn:hover {
          background: #e0e0e0;
        }

        .apply-btn {
          background: var(--primary);
          color: var(--white);
          border: none;
        }

        .apply-btn:hover {
          background: var(--primary-dark);
        }

        .checkboxes {
          display: flex;
          flex-direction: column;
          gap: 0.8rem;
        }

        .scrollable {
          max-height: 200px;
          overflow-y: auto;
          padding-right: 0.5rem;
        }

        .scrollable::-webkit-scrollbar {
          width: 5px;
        }

        .scrollable::-webkit-scrollbar-track {
          background: var(--light);
        }

        .scrollable::-webkit-scrollbar-thumb {
          background: var(--gray);
          border-radius: 5px;
        }

        .checkbox-item {
          display: flex;
          align-items: center;
          gap: 0.8rem;
        }

        .checkbox-item input {
          width: 18px;
          height: 18px;
          accent-color: var(--primary);
          cursor: pointer;
        }

        .checkbox-item label {
          cursor: pointer;
          font-size: 0.9rem;
          color: var(--dark);
          transition: var(--transition);
        }

        .checkbox-item:hover label {
          color: var(--primary);
        }

        .cards-container {
          width: 100%;
        }

        .cards {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
          gap: 2rem;
          margin-bottom: 2rem;
        }

        .card {
          background: var(--white);
          border-radius: 10px;
          overflow: hidden;
          box-shadow: var(--shadow);
          transition: var(--transition);
          position: relative;
        }

        .card:hover {
          transform: translateY(-5px);
                    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
        }

        .card-image-container {
          position: relative;
          height: 200px;
          overflow: hidden;
        }

        .card-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s ease;
        }

        .card:hover .card-image {
          transform: scale(1.05);
        }

        .badge {
          position: absolute;
          top: 1rem;
          left: 1rem;
          background: var(--primary);
          color: white;
          padding: 0.3rem 0.8rem;
          border-radius: 50px;
          font-size: 0.8rem;
          font-weight: 600;
          z-index: 1;
        }

        .location-tag {
          position: absolute;
          bottom: 1rem;
          left: 1rem;
          background: rgba(0, 0, 0, 0.7);
          color: white;
          padding: 0.3rem 0.8rem;
          border-radius: 50px;
          font-size: 0.8rem;
          z-index: 1;
        }

        .card-content {
          padding: 1.5rem;
        }

        .card-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-bottom: 1rem;
        }

        .card-title {
          font-size: 1.2rem;
          color: var(--dark);
          margin-right: 1rem;
        }

        .card-duration {
          display: flex;
          align-items: center;
          gap: 0.3rem;
          font-size: 0.9rem;
          color: var(--gray);
          white-space: nowrap;
        }

        .card-rating-price {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 1rem;
        }

        .card-rating {
          color: #ffc107;
          font-size: 0.9rem;
        }

        .card-rating span {
          color: var(--gray);
          margin-left: 0.3rem;
        }

        .card-price {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
        }

        .card-price .from {
          font-size: 0.8rem;
          color: var(--gray);
          margin-bottom: 0.2rem;
        }

        .card-price .price-amount {
          font-size: 1.2rem;
          font-weight: 700;
          color: var(--primary);
        }

        .card-price .per-person {
          font-size: 0.7rem;
          color: var(--gray);
        }

        /* Price options styles for cards */
        .price-options {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          gap: 0.3rem;
        }

        .price-option {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-size: 0.9rem;
        }

        .price-option .option-name {
          font-size: 0.8rem;
          color: var(--gray);
          font-weight: 500;
        }

        .price-option .price-amount {
          font-size: 1rem;
          font-weight: 600;
          color: var(--primary);
        }

        .single-price {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
        }

        .card-highlights {
          margin-bottom: 1.5rem;
        }

        .card-highlights h4 {
          font-size: 0.9rem;
          color: var(--dark);
          margin-bottom: 0.5rem;
        }

        .card-highlights p {
          font-size: 0.9rem;
          color: var(--gray);
          line-height: 1.5;
        }

        .card-footer {
          display: flex;
          justify-content: flex-end;
        }

        .view-btn {
          padding: 0.7rem 1.5rem;
          background: var(--primary);
          color: white;
          border: none;
          border-radius: 50px;
          font-weight: 600;
          cursor: pointer;
          transition: var(--transition);
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .view-btn:hover {
          background: var(--primary-dark);
          transform: translateY(-2px);
        }

        .load-buttons {
          display: flex;
          justify-content: center;
          gap: 1rem;
          margin-top: 2rem;
        }

        .load-more-btn,
        .show-less-btn {
          padding: 0.8rem 2rem;
          border-radius: 50px;
          font-weight: 600;
          cursor: pointer;
          transition: var(--transition);
        }

        .load-more-btn {
          background: var(--primary);
          color: white;
          border: none;
        }

        .load-more-btn:hover {
          background: var(--primary-dark);
          transform: translateY(-2px);
        }

        .show-less-btn {
          background: var(--light);
          color: var(--dark);
          border: none;
        }

        .show-less-btn:hover {
          background: #e0e0e0;
          transform: translateY(-2px);
        }

        .no-results {
          text-align: center;
          padding: 3rem;
          background: var(--white);
          border-radius: 10px;
          box-shadow: var(--shadow);
        }

        .no-results h3 {
          color: var(--dark);
          margin-bottom: 1rem;
        }

        .no-results p {
          color: var(--gray);
          margin-bottom: 1.5rem;
        }

        .loading-container {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 300px;
        }

        .spinner {
          width: 50px;
          height: 50px;
          border: 5px solid var(--light);
          border-top: 5px solid var(--primary);
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        /* Modal Styles */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.7);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
          padding: 1rem;
          overflow-y: auto;
        }

        .modal-container {
          background: white;
          border-radius: 10px;
          width: 100%;
          max-width: 900px;
          max-height: 90vh;
          overflow-y: auto;
          position: relative;
          box-shadow: 0 5px 30px rgba(0, 0, 0, 0.3);
          animation: fadeIn 0.3s ease;
        }

        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(-20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .modal-close-btn {
          position: absolute;
          top: 1rem;
          right: 1rem;
          background: none;
          border: none;
          font-size: 1.5rem;
          color: var(--gray);
          cursor: pointer;
          transition: var(--transition);
          z-index: 1;
        }

        .modal-close-btn:hover {
          color: var(--dark);
          transform: rotate(90deg);
        }

        .modal-header {
          padding: 2rem 2rem 1rem;
          border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        }

        .modal-header h2 {
          color: var(--dark);
          margin-bottom: 0.5rem;
        }

        .modal-subheader {
          display: flex;
          gap: 1.5rem;
          color: var(--gray);
          font-size: 0.9rem;
        }

        .modal-image-gallery {
          padding: 1rem 2rem;
        }

        .main-image {
          height: 400px;
          overflow: hidden;
          border-radius: 10px;
          margin-bottom: 1rem;
          cursor: pointer;
        }

        .main-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s ease;
        }

        .main-image:hover img {
          transform: scale(1.02);
        }

        .thumbnail-container {
          display: flex;
          gap: 1rem;
        }

        .thumbnail {
          width: 100px;
          height: 70px;
          border-radius: 5px;
          overflow: hidden;
          cursor: pointer;
          opacity: 0.7;
          transition: var(--transition);
        }

        .thumbnail:hover {
          opacity: 1;
          transform: translateY(-3px);
        }

        .thumbnail img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .image-popup-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.9);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 2000;
          padding: 2rem;
        }

        .image-popup-container {
          position: relative;
          max-width: 90%;
          max-height: 90%;
        }

        .popup-close-btn {
          position: absolute;
          top: -40px;
          right: 0;
          background: none;
          border: none;
          font-size: 2rem;
          color: white;
          cursor: pointer;
        }

        .popup-image {
          max-width: 100%;
          max-height: 80vh;
          object-fit: contain;
        }

        .modal-content {
          display: grid;
          grid-template-columns: 300px 1fr;
          gap: 2rem;
          padding: 0 2rem 2rem;
        }

        .modal-price-section {
          position: sticky;
          top: 1rem;
          height: fit-content;
        }

        .price-box {
          background: #f9f9f9;
          border-radius: 10px;
          padding: 1.5rem;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
        }

        .price-label {
          display: block;
          font-size: 0.9rem;
          color: var(--gray);
          margin-bottom: 0.5rem;
        }

        .price-box .price-amount {
          font-size: 2rem;
          font-weight: 700;
          color: var(--primary);
          margin: 0.5rem 0;
        }

        .price-box .price-per {
          font-size: 0.9rem;
          color: var(--gray);
        }

        /* Modal Price Options Styling */
        .modal-price-options {
          margin: 20px 0;
          width: 100%;
        }
        .price-section {
          background: #f8f9fa;
          border-radius: 8px;
          padding: 15px;
          box-shadow: 0 2px 4px rgba(0,0,0,0.05);
        }
        .price-header {
          display: flex;
          align-items: center;
          margin-bottom: 15px;
          padding-bottom: 10px;
          border-bottom: 1px solid #e9ecef;
        }
        .price-icon {
          color: #28a745;
          font-size: 18px;
          margin-right: 10px;
        }
        .price-title {
          margin: 0;
          color: #2c3e50;
          font-size: 16px;
          font-weight: 600;
        }
        .price-list {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }
        .price-option {
          display: flex;
          align-items: center;
          background: white;
          padding: 12px 15px;
          border-radius: 6px;
          box-shadow: 0 1px 3px rgba(0,0,0,0.05);
          transition: all 0.2s ease;
          border-left: 3px solid #e9ecef;
        }
        .price-option:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 8px rgba(0,0,0,0.1);
        }
        .price-option.highlighted {
          border-left-color: #28a745;
          background: linear-gradient(to right, #f8fff8, #ffffff);
        }
        .price-badge {
          background: #f1f8ff;
          color: #007bff;
          width: 28px;
          height: 28px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 600;
          font-size: 14px;
          margin-right: 15px;
          flex-shrink: 0;
        }
        .price-details {
          display: flex;
          flex-direction: column;
        }
        .price-value {
          font-size: 15px;
          font-weight: 500;
          color: #2c3e50;
        }
        .best-value {
          background: #28a745;
          color: white;
          font-size: 11px;
          padding: 2px 8px;
          border-radius: 10px;
          margin-top: 4px;
          align-self: flex-start;
          font-weight: 500;
        }
          border-left: 4px solid var(--primary);
        }

        .modal-price-option .option-label {
          font-size: 1rem;
          font-weight: 600;
          color: var(--dark);
        }

        .modal-price-option .option-price {
          font-size: 1.3rem;
          font-weight: 700;
          color: var(--primary);
        }

        .price-options {
          list-style: none;
          margin: 1rem 0;
          padding: 0;
        }

        .price-options li {
          padding: 0.5rem 0;
          border-bottom: 1px solid #eee;
          font-size: 0.9rem;
        }

        .price-options li:last-child {
          border-bottom: none;
        }

        .enquiry-now-btn,
        .download-pdf-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.5rem;
          width: 100%;
          padding: 0.8rem;
          margin-top: 1rem;
          border-radius: 5px;
          font-weight: 600;
          cursor: pointer;
          transition: var(--transition);
        }

        .enquiry-now-btn {
          background: var(--primary);
          color: white;
          border: none;
        }

        .enquiry-now-btn:hover {
          background: var(--primary-dark);
          transform: translateY(-2px);
        }

        .download-pdf-btn {
          background: white;
          color: var(--primary);
          border: 1px solid var(--primary);
        }

        .download-pdf-btn:hover {
          background: #f0f0f0;
          transform: translateY(-2px);
        }

        .modal-details-section {
          padding-right: 1rem;
        }

        .modal-details-section h3 {
          color: var(--primary);
          margin: 1.5rem 0 1rem;
          font-size: 1.2rem;
        }

        .highlights-list {
          list-style: none;
          padding: 0;
        }

        .highlights-list li {
          padding: 0.5rem 0;
          display: flex;
          align-items: flex-start;
          gap: 0.5rem;
        }

        .highlights-list svg {
          color: var(--primary);
          margin-top: 0.2rem;
          flex-shrink: 0;
        }

        .itinerary {
          margin-bottom: 1.5rem;
        }

        .day-plan {
          margin-bottom: 1.5rem;
        }

        .day-plan h4 {
          color: var(--dark);
          margin-bottom: 0.5rem;
          font-size: 1.1rem;
        }

        .day-plan p {
          color: var(--gray);
          line-height: 1.6;
          font-size: 0.9rem;
        }

        .inclusions-list,
        .exclusions-list {
          list-style: none;
          padding: 0;
        }

        .inclusions-list li,
        .exclusions-list li {
          padding: 0.5rem 0;
          display: flex;
          align-items: flex-start;
          gap: 0.5rem;
        }

        .inclusions-list svg {
          color: green;
          margin-top: 0.2rem;
          flex-shrink: 0;
        }

        .exclusions-list svg {
          color: red;
          margin-top: 0.2rem;
          flex-shrink: 0;
        }

        .terms {
          color: var(--gray);
          line-height: 1.6;
          font-size: 0.9rem;
        }

        /* Enquiry Form Styles */
        .enquiry-form {
          padding: 1rem 2rem 2rem;
        }

        .form-group {
          margin-bottom: 1rem;
        }

        .form-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 1rem;
        }

        .enquiry-form label {
          display: block;
          margin-bottom: 0.5rem;
          font-size: 0.9rem;
          color: var(--dark);
        }

        .enquiry-form input {
          width: 100%;
          padding: 0.8rem 1rem;
          border: 1px solid #ddd;
          border-radius: 5px;
          font-size: 0.9rem;
        }

        .enquiry-form input:focus {
          outline: none;
          border-color: var(--primary);
        }

        .submit-btn {
          width: 100%;
          padding: 0.8rem;
          background: var(--primary);
          color: white;
          border: none;
          border-radius: 5px;
          font-weight: 600;
          cursor: pointer;
          transition: var(--transition);
          margin-top: 1rem;
        }

        .submit-btn:hover {
          background: var(--primary-dark);
          transform: translateY(-2px);
        }

        /* Responsive Styles */
        @media (max-width: 1024px) {
          .layout {
            grid-template-columns: 1fr;
          }

          .filter-container {
            position: static;
          }

          .modal-content {
            grid-template-columns: 1fr;
          }

          .modal-price-section {
            position: static;
          }
        }

        @media (max-width: 768px) {
          .cards {
            grid-template-columns: 1fr;
          }

              .form-row {
                grid-template-columns: 1fr;
              }

              .modal-image-gallery {
                padding: 1rem;
              }

              .main-image {
                height: 300px;
              }

              .modal-content {
                padding: 0 1rem 1rem;
              }
        }

        @media (max-width: 480px) {
          .title {
            font-size: 2rem;
          }

          .subtitle {
            font-size: 1rem;
          }

          .search-box input {
            padding: 1rem;
          }

          .card-title {
            font-size: 1.1rem;
          }

          .card-duration {
            font-size: 0.8rem;
          }

          .card-price .amount {
            font-size: 1.1rem;
          }

          .modal-header {
            padding: 1.5rem 1rem 1rem;
          }

          .modal-subheader {
            flex-direction: column;
            gap: 0.5rem;
          }

          .thumbnail-container {
            flex-wrap: wrap;
          }

          .thumbnail {
            width: 80px;
            height: 60px;
          }
        }
      `}</style>
    </>
  );
}